var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageSvhThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 195,
    viewBox: "0 0 272 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1102_5160)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9998 10C32.1633 10 24.9998 17.1634 24.9998 26V44.2127L10.2466 60.7597C9.75376 61.3124 10.1295 62.0583 10.9391 62.1344L24.9998 63.4562V169C24.9998 177.837 32.1633 185 40.9998 185H246C254.836 185 262 177.837 262 169V26C262 17.1634 254.836 10 246 10H40.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 44.2127L26.1194 45.211L26.4998 44.7843V44.2127H24.9998ZM10.2466 60.7597L9.127 59.7614H9.127L10.2466 60.7597ZM10.9391 62.1344L10.7987 63.6278H10.7987L10.9391 62.1344ZM24.9998 63.4562H26.4998V62.0906L25.1402 61.9628L24.9998 63.4562ZM26.4998 26C26.4998 17.9919 32.9917 11.5 40.9998 11.5V8.5C31.3348 8.5 23.4998 16.335 23.4998 26H26.4998ZM26.4998 44.2127V26H23.4998V44.2127H26.4998ZM11.3662 61.7579L26.1194 45.211L23.8802 43.2145L9.127 59.7614L11.3662 61.7579ZM11.0795 60.641C11.1046 60.6433 11.3097 60.6843 11.4441 60.951C11.5101 61.082 11.5418 61.2438 11.5177 61.4108C11.4935 61.5791 11.4212 61.6962 11.3662 61.7579L9.127 59.7614C8.49067 60.4751 8.341 61.4593 8.76478 62.3006C9.16613 63.0974 9.96392 63.5493 10.7987 63.6278L11.0795 60.641ZM25.1402 61.9628L11.0795 60.641L10.7987 63.6278L24.8594 64.9496L25.1402 61.9628ZM26.4998 169V63.4562H23.4998V169H26.4998ZM40.9998 183.5C32.9917 183.5 26.4998 177.008 26.4998 169H23.4998C23.4998 178.665 31.3348 186.5 40.9998 186.5V183.5ZM246 183.5H40.9998V186.5H246V183.5ZM260.5 169C260.5 177.008 254.008 183.5 246 183.5V186.5C255.665 186.5 263.5 178.665 263.5 169H260.5ZM260.5 26V169H263.5V26H260.5ZM246 11.5C254.008 11.5 260.5 17.9919 260.5 26H263.5C263.5 16.335 255.665 8.5 246 8.5V11.5ZM40.9998 11.5H246V8.5H40.9998V11.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1102_5160",
    x: 0.52533,
    y: 0.5,
    width: 270.974,
    height: 194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.365319 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1102_5160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1102_5160",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSvhThree);
export default __webpack_public_path__ + "static/media/message_svh_three.d06a7d436c355277cef06bf95c5233a4.svg";
export { ForwardRef as ReactComponent };